import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  Conductivityprofiles,
  ListConductivityprofiles,
} from 'src/app/models/conductivityprofiles.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';

@Component({
  selector: 'app-edit-conductivityprofiles',
  templateUrl: './edit-conductivityprofiles.component.html',
  styleUrls: ['./edit-conductivityprofiles.component.scss'],
})
export class EditConductivityprofilesComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private plantsService: PlantsService,
    private trainService: TrainService,
    private conductivityprofilesservice: ConductivityprofilesService,
    private toastr: ToastrService,
    private plantService: PlantsService
  ) {}

  trainDetails: Train = new Train();

  ListConductivityprofilesDetails: ListConductivityprofiles =
    new ListConductivityprofiles();
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  plants: Plant[] = [];
  trains: Train[] = [];
  dateNow: Date = new Date();
  SelectedId: string;
  trainId: string;
  plantId: string;
  conductivityprofil_Id: any;

  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;

  getSelectedId(e) {
  
    this.SelectedId = e.target.value;
    this.trains.length = 0;

    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.plantId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
  }
  getSelectedIdstart(e) {
    this.trainService.getTrainByPlantId(e).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantsService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantsService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
    this.route.paramMap.subscribe({
      next: (params) => {
       
        const id = atob(params.get('id')!);

        if (id) {
          this.conductivityprofilesservice
            .getConductivityprofilesById(id)
            .subscribe({
              next: (response) => {
                this.ListConductivityprofilesDetails = response;
                console.log(this.ListConductivityprofilesDetails);
                this.trainId =
                  this.ListConductivityprofilesDetails.TrainId.toString();

                this.trainService.getTrainById(this.trainId).subscribe({
                  next: (response) => {
                    this.trainDetails = response;
                    console.log(this.trainDetails);
                    this.trains.length = 0;
                    this.plantId = this.trainDetails.PlantId.toString();

                    this.getSelectedIdstart(this.plantId);
                  },
                });

                
              },
            });
        }
      },
    });

    // get plantId from breadcrumbs
    this.plantService.selectedPlant$
      .subscribe(plantId => {
        if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
        }
      });
  }

  updateConductivityprofile() {
    const dateNowISO = this.dateNow.toISOString();
    this.ListConductivityprofilesDetails.UpdatedAt = dateNowISO;
    console.log(this.ListConductivityprofilesDetails);

    this.conductivityprofilesservice
      .updateConductivityprofiles(
        this.ListConductivityprofilesDetails.Id,
        this.ListConductivityprofilesDetails
      )
      .subscribe({
        next: (response) => {
          this.toastr.success(
            'Conductivity Profile Updated Successfully.',
            'Information'
          );
          this.router.navigate(['/conductivityprofile']);
        },
      });
  }

  deleteConductivityprofile(id: number) {
    this.conductivityprofil_Id = id + '';
    const confirmDelete = confirm(
      'Are you sure you want to delete this Conductivity Profile?'
    );

    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }

    this.conductivityprofilesservice
      .deleteConductivityprofiles(this.conductivityprofil_Id)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.error('Conductivity Profile deleted successfully.', 'Information');
          this.router.navigate(['/conductivityprofile']);
        } else {
          (error) => {
            console.log('Error deleting Conductivity Profile:', error);
          };
        }
      });
  }
}
